export default __webpack_public_path__ + "static/media/denisa.60f5531d.jpg";